@use '../../../styles/mixins/typography-mixin' as *;

.body-text {
  @include body_text();
}
